/**
* DevExpress Dashboard (_color-style-settings.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { Color } from '../../../color';
import { appearanceType } from './_appearance-settings';
import { styleSettingsBaseSerializationsInfo } from './_style-settings-base';
export let predefinedColor = {
    propertyName: 'predefinedColor', modelName: '@PredefinedColor', displayName: 'DashboardStringId.FormatRulePredefinedColor', defaultVal: appearanceType.defaultVal, simpleFormAdapterItem: appearanceType.simpleFormAdapterItem, values: appearanceType.values
};
export let color = { propertyName: 'color', modelName: '@Color', displayName: 'DashboardStringId.DescriptionItemColor', defaultVal: null, from: Color._colorFromModel, toJsonObject: Color._colorToModel, simpleFormAdapterItem: 'numberBoxEditor' };
export let colorStyleSettingsSerializationsInfo = styleSettingsBaseSerializationsInfo.concat([color, predefinedColor]);
